import {AxiosInstance} from "axios";

/**
 * Api for Revolut authorization.
 */
export default class RevolutAuthApi {
	constructor(public readonly axiosInstance: AxiosInstance) {}

	revolutAuth(code: string, clientId: string) {
		const url = `/api/web/accounting/revolut_authorisation`;
		const revolutAuthData = {
			code,
			clientId
		};
		return this.axiosInstance.post(url, revolutAuthData);
	}
}